import Vue from 'vue'
import Vuex from 'vuex'
import { EventBus } from '@/services/eventbus'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    auth: localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {},
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
    rootPath: localStorage.getItem('rootPath') ? localStorage.getItem('rootPath') : '',
    request: localStorage.getItem('request') ? JSON.parse(localStorage.getItem('request')) : [],
    favorites: localStorage.getItem('favorites') ? JSON.parse(localStorage.getItem('favorites')) : [],
    favoritesItems: [],
    favoritesLoadIndex: 0,
    folders: [],
    view: {
      desktop: localStorage.getItem('viewDesktop') ? JSON.parse(localStorage.getItem('viewDesktop')) : 4,
      mobile: localStorage.getItem('viewMobile') ? JSON.parse(localStorage.getItem('viewMobile')) : 2
    },
    categories: [],
    lastActiveFilter: {
      field: null,
      values: []
    },
    activeCategory: null,
    expandedFilter: [],
    activeFilter: [],
    checkedValues: [],
    filters: [],
    filtersOrder: [],
    assetQuery: {
      search: '',
      filter: [],
      path: '',
      imageSize: 'medium',
      pagination: {
        size: process.env.VUE_APP_API_PAGINATION_SIZE,
        startingIndex: 0
      },
      sort: {
        field: 'Cataloged',
        order: 'desc'
      }
    },
    cartCount: 0
  },
  mutations: {
    SET_AUTH (state, payload) {
      state.auth = payload
    },
    SET_USER (state, payload) {
      state.user = payload
      window.localStorage.setItem('user', JSON.stringify(payload))
    },
    SET_FAVORITES (state, payload) {
      state.favorites = payload
      window.localStorage.setItem('favorites', JSON.stringify(payload))
    },
    SET_FAVORITES_LOAD_INDEX (state, payload) {
      state.favoritesLoadIndex = payload
    },
    SET_FOLDERS (state, payload) {
      state.folders = payload
    },
    SET_ROOT_PATH (state, payload) {
      state.rootPath = payload
      window.localStorage.setItem('rootPath', JSON.stringify(payload))
    },
    SET_GRID_VIEW (state, payload) {
      state.view = payload
      window.localStorage.setItem('viewDesktop', JSON.stringify(payload.desktop))
      window.localStorage.setItem('viewMobile', JSON.stringify(payload.mobile))
    },
    SET_EXPANDED_FILTER (state, payload) {
      state.expandedFilter = payload
    },
    SET_ACTIVE_FILTER (state, payload) {
      state.activeFilter = payload
    },
    SET_SIDEBAR_VALUES (state, payload) {
      state.view = payload
    },
    SET_ASSET_QUERY (state, payload) {
      state.assetQuery = payload
      window.localStorage.setItem('assetQuery', JSON.stringify(payload))
      EventBus.$emit('asset-query', true)
    },
    SET_FAVORITES_ITEMS (state, payload) {
      if (!payload.length) {
        state.favoritesItems = payload
        return
      }

      state.favoritesItems = state.favoritesItems.concat(payload)
    },
    SET_REQUEST_ITEMS (state, payload) {
      Vue.set(state, 'request', payload)
      state.request = payload
      window.localStorage.setItem('request', JSON.stringify(payload))
    }
  },
  getters: {
    cartCount: state => {
      let cart = window.localStorage.getItem('request')
      if (cart == null) {
        return state.cartCount
      }
      return JSON.parse(cart).length
    }
  },
  actions: {
    setAuth (context, payload) {
      if (typeof payload.expires_at !== 'undefined' && payload.expires_at !== null) {
        payload.expires_at = payload.expires_in + Math.round(Date.now() / 1000)
      }
      context.commit('SET_AUTH', payload)
      window.localStorage.setItem('auth', JSON.stringify(payload))
    },
    setUser (context, payload) {
      context.commit('SET_USER', payload)
    },
    setFavoritesItems (context, payload) {
      context.commit('SET_FAVORITES_ITEMS', payload)
    },
    setFavorites (context, payload) {
      context.commit('SET_FAVORITES', payload)
    },
    setFavoritesLoadIndex (context, payload) {
      context.commit('SET_FAVORITES_LOAD_INDEX', payload)
    },
    setFolders (context, payload) {
      context.commit('SET_FOLDERS', payload)
    },
    setLogout (context) {
      window.localStorage.removeItem('user')
      window.localStorage.removeItem('auth')
      window.localStorage.removeItem('request')
      window.localStorage.removeItem('favorites')
      window.localStorage.removeItem('rootPath')
      window.localStorage.removeItem('assetQuery')
      context.commit('SET_USER', {})
      context.commit('SET_AUTH', {})
      context.commit('SET_REQUEST_ITEMS', [])
      context.commit('SET_ROOT_PATH', '')
    },
    setRootPath (context, payload) {
      context.commit('SET_ROOT_PATH', payload)
    },
    addRequestItem (context, payload) {
      let index = this.state.request.findIndex(function (items) { return items.id === payload.id })
      if (index === -1) {
        this.state.request.push({
          id: payload.id,
          filename: payload.attributes.Filename[0],
          path: payload.attributes.Path[0],
          preview: typeof payload.attributes['Thumbnail'] !== 'undefined' ? payload.attributes['Thumbnail'][0] : ''
        })
        context.commit('SET_REQUEST_ITEMS', this.state.request)
      }
    },
    removeRequestItem (context, payload) {
      if (payload.all) {
        this.state.request.splice(0, this.state.request.length)
        context.commit('SET_REQUEST_ITEMS', this.state.request)
      } else {
        let index = this.state.request.findIndex(function (items) { return items.id === payload.item.id })
        if (index !== -1) {
          this.state.request.splice(index, 1)
          context.commit('SET_REQUEST_ITEMS', this.state.request)
        }
      }
    },
    addExpandedFilter (context, payload) {
      this.state.expandedFilter.push(payload)
      context.commit('SET_EXPANDED_FILTER', this.state.expandedFilter)
    },
    removeExpandedFilter (context, index) {
      this.state.expandedFilter.splice(index, 1)
      context.commit('SET_EXPANDED_FILTER', this.state.expandedFilter)
    },
    addActiveFilter (context, payload) {
      this.state.activeFilter.push(payload)
      context.commit('SET_ACTIVE_FILTER', this.state.activeFilter)
    },
    removeActiveFilter (context, index) {
      this.state.activeFilter.splice(index, 1)
      context.commit('SET_ACTIVE_FILTER', this.state.activeFilter)
    },
    setGridView (context, payload) {
      context.commit('SET_GRID_VIEW', payload)
    },
    setSidebarValues (context, payload) {
      if (payload.type === 'categories') {
        this.state.categories = payload.value
      }
      if (payload.type === 'lastActiveFilter') {
        this.state.lastActiveFilter = payload.value
      }
      if (payload.type === 'activeCategory') {
        this.state.activeCategory = payload.value
      }
      if (payload.type === 'expandedFilter') {
        this.state.expandedFilter = payload.value
        context.commit('SET_EXPANDED_FILTER', this.state.expandedFilter)
      }
      if (payload.type === 'activeFilter') {
        this.state.activeFilter = payload.value
      }
      if (payload.type === 'checkedValues') {
        this.state.checkedValues = payload.value
      }
      if (payload.type === 'filters') {
        this.state.filters = payload.value
      }
      if (payload.type === 'filtersOrder') {
        this.state.filtersOrder = payload.value
      }
    },
    setAssetQuery (context, payload) {
      if (typeof payload.pagination !== 'undefined') {
        this.state.assetQuery.pagination.size = payload.pagination.size
        this.state.assetQuery.pagination.startingIndex = payload.pagination.startingIndex
      }
      if (typeof payload.sort !== 'undefined') {
        this.state.assetQuery.sort.field = payload.sort.key
        this.state.assetQuery.sort.order = payload.sort.value
        this.state.assetQuery.pagination = {
          size: process.env.VUE_APP_API_PAGINATION_SIZE,
          startingIndex: 0
        }
      }
      if (typeof payload.search !== 'undefined') {
        this.state.assetQuery.search = payload.search
        this.state.assetQuery.path = this.state.rootPath
        this.state.assetQuery.filter = []
        this.state.assetQuery.pagination = {
          size: process.env.VUE_APP_API_PAGINATION_SIZE,
          startingIndex: 0
        }
      }
      if (typeof payload.filter !== 'undefined') {
        this.state.assetQuery.filter = JSON.parse(JSON.stringify(payload.filter))
        this.state.assetQuery.pagination = {
          size: process.env.VUE_APP_API_PAGINATION_SIZE,
          startingIndex: 0
        }
      }
      if (typeof payload.path !== 'undefined') {
        this.state.assetQuery.path = payload.path
        this.state.assetQuery.search = payload.search
        this.state.assetQuery.filter = []
        this.state.assetQuery.pagination = {
          size: process.env.VUE_APP_API_PAGINATION_SIZE,
          startingIndex: 0
        }
      }
      if (typeof payload.imageSize !== 'undefined') {
        this.state.assetQuery.imageSize = payload.imageSize
        this.state.assetQuery.pagination = {
          size: process.env.VUE_APP_API_PAGINATION_SIZE,
          startingIndex: 0
        }
      }
      context.commit('SET_ASSET_QUERY', this.state.assetQuery)
    }
  }
})
